// @systeme: contrat
// Un document : une photo (mot d'école, facture, ordonnance) rattachée à une capture puis
// à l'élément qui en sort. Le fichier reste sur le serveur ; ici, ce qu'on en montre.
import { z } from 'zod';
import { SchemaSensibilite } from '../enumerations.js';
import { SchemaInstant } from './elements.js';
export const SchemaDocument = z.object({
    id: z.uuid(),
    captureId: z.uuid().nullable(),
    elementId: z.uuid().nullable(),
    nom: z.string(),
    typeMime: z.string(),
    tailleOctets: z.number().int(),
    /** « sante » : dit par l'utilisatrice avant l'envoi ; un tel document n'est jamais lu par un modèle (DEC-019). */
    sensibilite: SchemaSensibilite,
    creeLe: SchemaInstant,
});
//# sourceMappingURL=documents.js.map